import LandingPageLayout from 'components/LandingPageLayout';
import StaysLocation from 'components/LandingPageStaysLocation';
import React from 'react';
import AboutUsSlider from 'components/LandingPageAboutUsSlider';
import CostGraph from 'components/LandingPageCostGraph';
import AboutUs from 'components/LandingPageAboutUs';
import WhyUs from 'components/LandingPageWhyUs';
import Blogs from 'components/LandingPageBlogs';
import AmenityColiving from 'components/LandingPageAmenitiesLiberty/AmenityColiving';
import Head from 'next/head';
const CoLivingInToronto = () => {
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Co-living options in the city</title>
        <meta
          name="description"
          content="Landlords on soulrooms offer entire properties by the room too, so that you do not have to look for them as a sublet or get into scams."
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/co-living-in-toronto" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Co-living options in the city" />
        <meta
          property="og:description"
          content="Landlords on soulrooms offer entire properties by the room too, so that you do not have to look for them as a sublet or get into scams."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Landlords on soulrooms offer entire properties by the room too, so that you do not have to look for them as a sublet or get into scams."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />

        <link rel="canonical" href="https://www.soulrooms.com/co-living-in-toronto" />
      </Head>
      <LandingPageLayout>
        <StaysLocation
          img={'/static/images/landingPages/coliving.png'}
          title={'CO-LIVING IN TORONTO SIMPLIFIED.'}
          description={
            "Spacious rooms, trendy common spaces, friendly flatmates, engaging community events are some of the things you will find at SoulRooms. Since you are exploring co-living in the city, why not chose the very best and move in with us. It's as easy as a three-day weekend!"
          }
          btnTitle={'Let us find you a SoulRoom'}
          bg="black"
          href="/find-a-soulroom"
        />

        {/*  WHY CHOOSE SOULROOMS SECTION  */}
        <WhyUs
          spacing={true}
          bg="none"
          title="HOW IT WORKS"
          heading1="Discover Properties"
          detail1="Find properties and rooms that suit your style and budget."
          heading2="Review Listings"
          detail2="Check out photos, plans, and virtual tours to decide on your perfect rental. "
          heading3="Book & Move"
          detail3="Our online booking and integrated approvals make it easy for landlords and tenants to close the deal."
          img1="/static/images/landingPages/HomePage/howitworks1.png"
          img2="/static/images/landingPages/HomePage/howitworks2.png"
          img3="/static/images/landingPages/HomePage/howitworks3.png"
        />
        <AmenityColiving
          heading="SOULROOMS IS ALL ABOUT"
          title1="Comfort"
          title2="Convenience"
          title3="Community"
          img1={'/static/images/landingPages/comfort.png'}
          img2={'/static/images/landingPages/conveniance.png'}
          img3={'static/images/landingPages/community.png'}
        />
        <AboutUs blackBackground={true} />
      </LandingPageLayout>
    </div>
  );
};

export default CoLivingInToronto;
